import React, { useState, useEffect } from 'react';
import {
  Button,
  Drawer,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
} from '@one-thd/sui-atomic-components';
import {
  setSelectedPickupDate,
  useSummaryStore,
} from '@src/stores/summaryStore';
import {
  setReturnShipments,
  setShowCalendar,
  useReturnStore,
} from '@src/stores/returnStore';
import { LORPSchedulePickupStep } from '@src/components/lorp/lorp-schedule-pickup/LORPSchedulePickupStep';
import {
  DATE_TIME_ADJUSTMENT,
  MORE_DATES_VALUE,
  REQUEST_DIFFERENT_DATE_VALUE,
} from '@src/utils/calendar';

interface PickupDateDrawerProps {
  open: boolean;
  onClose: () => void;
}

export const PickupDateDrawer: React.FC<PickupDateDrawerProps> = ({
  open,
  onClose,
}) => {
  const selectedPickupDate = useSummaryStore(
    (state) => state.selectedPickupDate,
  );
  const showCalendar = useReturnStore((state) => state.showCalendar);
  const [savedPickupDate, setSavedPickupDate] = useState(selectedPickupDate);
  const [savedShowCalendar, setSavedShowCalendar] = useState(showCalendar);
  const returnShipments = useReturnStore((state) => state.returnShipments);
  const pickupDateToPersist =
    !selectedPickupDate ||
    selectedPickupDate === REQUEST_DIFFERENT_DATE_VALUE ||
    selectedPickupDate === MORE_DATES_VALUE
      ? ''
      : selectedPickupDate.replace(DATE_TIME_ADJUSTMENT, '');

  // Capture current state when the drawer opens
  useEffect(() => {
    if (open) {
      setSavedPickupDate(selectedPickupDate);
      setSavedShowCalendar(showCalendar);
    }
  }, [open]);

  const handleUpdate = () => {
    if (returnShipments) {
      setReturnShipments(
        returnShipments.map((shipment) => {
          if (shipment.shipmentType === 'PICKUP') {
            return {
              ...shipment,
              pickupDate: pickupDateToPersist,
            };
          }
          return shipment;
        }),
      );
    }
    onClose();
  };

  const handleCancel = () => {
    setSelectedPickupDate(savedPickupDate);
    setShowCalendar(savedShowCalendar);
    onClose();
  };

  return (
    <Drawer
      open={open}
      onClose={handleCancel}
      position="right"
      className="drawer-z-index-fix"
    >
      <DrawerHeader
        title="Pickup Date"
        onClose={handleCancel}
        data-testid="Pickup-Date"
      />
      <DrawerBody>
        <LORPSchedulePickupStep />
      </DrawerBody>
      <DrawerFooter className="sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky sui-shadow-sm">
        <div className="sui-flex sui-gap-4 sui-flex-col">
          <Button fullWidth onClick={handleUpdate}>
            Update
          </Button>
          <Button fullWidth variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
        </div>
      </DrawerFooter>
    </Drawer>
  );
};
